import App from './App.tsx'
import { AuthProvider } from './contexts/AuthContext'
import { BrowserRouter } from 'react-router-dom'
import { createRoot } from 'react-dom/client'
import { GoogleOAuthProvider } from '@react-oauth/google'
import * as Sentry from '@sentry/react'
import { StrictMode } from 'react'

import '@ant-design/v5-patch-for-react-19'
import 'antd/dist/reset.css'

import './main.css'

import { ImpersonationProvider } from './contexts/ImpersonationContext/index.tsx'
import { SettingsProvider } from './contexts/SettingsContext/index.tsx'

const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN

Sentry.init({
  dsn: SENTRY_DSN || '',
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 1.0,
  tracePropagationTargets: ['localhost', /^https:\/\/agents\.turbodebt\.\/com/],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
})

const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID
if (!GOOGLE_CLIENT_ID) {
  throw new Error('VITE_GOOGLE_CLIENT_ID is not defined')
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <SettingsProvider>
        <AuthProvider>
          <ImpersonationProvider>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </ImpersonationProvider>
        </AuthProvider>
      </SettingsProvider>
    </GoogleOAuthProvider>
  </StrictMode>,
)
